import { all, call, put, take, select, takeLatest } from 'redux-saga/effects'
import { CalendarActions } from '../../reducers/bookingCalendar/actionNames'
import { localStorage } from '../../database'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'
import { ActionNames } from '../../utils/FetchActionsName'
import { callFetch } from '../../actions/fetch'
import setSurveyModalDisplay from '../../models/Calendar/setSurveyModalDisplay'
import { getUserPollDisplayed } from '../../reducers/userAccount/selectors/userAccount'

function* setOnbordingModal() {
  const { UserDriver: Driver, Names } = localStorage

  Driver.setItem(Names.UserAccountStorage.SetOnbordingModal, '1')
  yield ''
}

function* openOnbordingModal() {
  const { UserDriver: Driver, Names } = localStorage

  const onbordingModal = Driver.getItem(
    Names.UserAccountStorage.SetOnbordingModal,
    '0',
  )

  const survey = yield select(getUserPollDisplayed)

  if(survey){
    if (onbordingModal === '0') {
      yield put({ type: CalendarActions.ToggleOnbordingModal, payload: true })
    }
  } else {
    yield put({type: CalendarActions.ToggleSurveyModal, payload: true})
  }


}

function* setSurveyModal() {
  try {
    const actionNames = fetchActionsName(ActionNames.SetSurveyModalShow)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(callFetch(actionNames.input, actionNames.output, setSurveyModalDisplay)),
    ])

    yield call(service)
  } catch (e) {
   console.error(e)
  }
}

export default function*() {
  yield takeLatest(CalendarActions.SetOnbordingShow, setOnbordingModal)
  yield takeLatest(CalendarActions.OpenOnbordingModal, openOnbordingModal)
  yield takeLatest(CalendarActions.SetSurveyModalShow, setSurveyModal)
}
